import React, { useContext } from "react";
import Commontooltip from "../../../CommonTooltip/Commontooltip";
import yellodownarrow from "../../../../Assests/Images/yellowuparrow.svg";
import yellouparrow from "../../../../Assests/Images/yellowdownarrow.svg";
import { ReadingReportContrext } from "../ReadingReportsTable";

function DateHeaderStyle() {
  const context = useContext(ReadingReportContrext);
  const {
    deviceList,
    pageSize,
    pageind,
    GetList,
    setIsChecked,
    SetCheckedArray,
    isChecked,
    CheckedArray,
    isAlert,
    AlphabetType,
    isTime,
    Values,
    ChangeOrderType,
    OBJKeys,
    communicationfailvalue,
  } = context || {};

  return (
    <>
      <th rowSpan={2}>
        <div
          style={{
            width: "90px",
            marginTop: 0,
            background: "transparent",
            padding: 0,
          }}
        >
          <div
            style={{
              display: "flex",
              alignItems: "center",
              gap: "11px",
              justifyContent: "space-between",
            }}
          >
            <p style={{ color: "white" }}>Date</p>

            <div style={{ display: "flex", flexDirection: "column" }}>
              <Commontooltip
                children={
                  <img
                    src={yellouparrow}
                    style={{ width: "9px" }}
                    onClick={() => {
                      GetList &&
                        GetList(
                          deviceList?.page,
                          30,
                          Values,
                          false,
                          false,
                          "created_at",
                          "asc",
                          isChecked?.pin_1_status,
                          isChecked?.pin_2_status,
                          isChecked?.pin_3_status,
                          isAlert,
                          isTime,
                          communicationfailvalue
                        );
                      ChangeOrderType && ChangeOrderType("created_at", "asc");
                    }}
                    alt="yellouparrow"
                  />
                }
                msg="Ascending"
              />

              <Commontooltip
                children={
                  <img
                    src={yellodownarrow}
                    style={{ width: "9px" }}
                    onClick={() => {
                      GetList &&
                        GetList(
                          1,
                          30,
                          Values,
                          false,
                          false,
                          "created_at",
                          "desc",
                          // isChecked?.isEbchecked,
                          // isChecked?.isDgchecked,

                          isChecked?.pin_1_status,
                          isChecked?.pin_2_status,
                          isChecked?.pin_3_status,

                          isAlert,
                          isTime,
                          communicationfailvalue
                        );
                      ChangeOrderType && ChangeOrderType("created_at", "desc");
                    }}
                    alt="yellodownarrow"
                  />
                }
                msg="Descending"
                placement="bottom"
              />
            </div>
          </div>
        </div>

        {/* <CommonArows
            margintop={0}
            Show="ordertype"
            Headername="Date"
            handleAscending={() => {
              GetList(
                deviceList?.page,
                30,
                Values,
                false,
                false,
                "created_at",
                "asc",
                // isChecked?.isEbchecked,
                // isChecked?.isDgchecked,

                isChecked?.pin_1_status,
                isChecked?.pin_2_status,
                isChecked?.pin_3_status,

                isAlert,
                isTime,
                communicationfailvalue
              );
              ChangeOrderType("created_at", "asc");
            }}
            handleDescending={() => {
              GetList(
                1,
                30,
                Values,
                false,
                false,
                "created_at",
                "desc",
                // isChecked?.isEbchecked,
                // isChecked?.isDgchecked,

                isChecked?.pin_1_status,
                isChecked?.pin_2_status,
                isChecked?.pin_3_status,

                isAlert,
                isTime,
                communicationfailvalue
              );
              ChangeOrderType("created_at", "desc");
            }}
          /> */}
      </th>
    </>
  );
}

export default DateHeaderStyle;
